module.exports = __webpack_public_path__ + "img/WordCloud2.e2bf415d.png";